<div class="export-data">
  <h3 class="heading">{{ 'ENTER_KEY_DETAILS' | translate }}</h3>
</div>

<!-- PDF Component -->
<div  >
  <mtn-store-add-pdf-page

    [formData]="getFormData()"
    [summaryData]="getSummaryData()"
    [competitiveData]="getCompetitiveData()"
    [location]="wizard?.model?.location"
    [cbsaName]="cbsaName"
    [regionType]="demographicRegionType"
    [regionValue]="demographicRegionValue"
    [competitiveRegionType]="regionType"
    [competitiveRegionValue]="regionValue"
    [keyIndicator]="keyIndicator"
    [sqftWarningData]="sqftWarningData"
    [bannerCBSAAverages]="bannerCBSAAverages"
    #pdfComponent>
  </mtn-store-add-pdf-page>
</div>

<div class="store-field" [ngClass]="(isSubmitted && !isInitialized) ? 'disabled' : ''" [formGroup]="newUserForm" style="display: block;">
  <div style="display: flex;">
    <div class="form-div">
    <label for="grocer-input" class="">{{ 'SELECT_GROCER' | translate }} <span class="required-asterisk">*</span></label>

      <mat-form-field (click)="grocerSelectionReset()" class="input-field" appearance="outline">
        <input
          type="text"
          matInput
          [placeholder]="'SEARCH_FOR_A_GROCER' | translate"
          formControlName="grocer"
          [matAutocomplete]="auto"
          (input)="onGrocerInput()"
        />

        <mat-autocomplete
          panelClass="custom-autocomplete-panel"
          #auto="matAutocomplete"
          [displayWith]="displayGrocerName"
          (optionSelected)="onGrocerOptionSelected($event)"
        >
          <mat-option
            *ngFor="let store of filteredStores | async"
            [value]="store"
        >
            {{ store?.StoreName }} ({{ store.DefaultFit }})
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="newUserForm.get('grocer').hasError('required')">
          <i>{{ 'MUST_BE_PROVIDED' | translate }}</i>
        </mat-error>
        <mat-error *ngIf="newUserForm.get('grocer').hasError('notSelected')">
          <i>{{ 'SELECT_GROCER_FROM_LIST' | translate }}</i>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-div sqftDiv">
      <label>{{ 'PROJECTED_STORE_SIZE' | translate }} <span class="required-asterisk">*</span> </label>
      <mtn-number-field
        [requiredMessage]="'ENTER_INTEGER_VALUE' | translate"
        [form]="newUserForm"
        (click)="grocerSqftReset()"
        controlName="sqft"
        [isRequired]="true"
        class="input-field"
        [placeholder]="'ENTER_EXPECTED_SQUARE_FOOTAGE' | translate"
      ></mtn-number-field>
    </div>
  </div>

  <div class="form-div sqftDiv1" style="width: 100%;">
    <label for="sales-area-input">{{ 'PROJECTED_STORE_SALES_AREA_SQFT' | translate }}</label>
    <div class="helper-text" style="font-size: 12px; color: #8d8d8d;font-weight: 520;margin-top: -5px;">{{ 'HELPER_TEXT' | translate }}</div>
    <mtn-number-field
      [requiredMessage]="'ENTER_INTEGER_VALUE' | translate"
      [form]="newUserForm"
      (click)="grocerSqftReset()"
      controlName="salesArea"
      [isRequired]="false"
      class="input-field"
      [placeholder]="'ENTER_EXPECTED_SQUARE_FOOTAGE' | translate"
    ></mtn-number-field>
  </div>
</div>
<mtn-spinner [size]="SpinnerSize.LARGE"  [on]="(isSubmitted && !isInitialized)"></mtn-spinner>
<!-- <div *ngIf="!showDetails" class="beta-text">
  The Point-and-click feature remains in beta and is trained on legacy data at this stage. We’re actively refining our model to improve speed, usability, and accuracy. Full data coverage is scheduled for release in Q4 2025
</div> -->

<div *ngIf="showDetails">
  <div [ngClass]="!isSubmitted ? 'hide' : ''">
    <app-summary-details
      [isSubmitted]="isSubmitted"
      [isInitialized]="isInitialized"
      [weeklySalesLowerRange]="weeklySalesLowerRange * areaSales"
      [weeklySalesUpperRange]="weeklySalesUpperRange * areaSales"
      [totalSalesProjectionStatus]="totalSalesProjectionStatus"
      [sqftProjectionStatus]="sqftProjectionStatus"
      [bannerCBSAAverages]="bannerCBSAAverages"
      [cbsaName]="cbsaName"
      [nearestStore]="nearestStore"
      [densityClass]="densityClass"
      [closetCompetitor]="closetCompetitor"
      [futureStoreCount]="futureStoreCount"
      [nearestFutureStoreDistance]="nearestFutureStoreDistance"
      [nearestFutureStoreName]="nearestFutureStoreName"
    ></app-summary-details>

    <div [ngClass]="!isSubmitted ? 'hide' : ''" class="demographic-view">
      <div class="comparison-detail-page-container container" fxLayout="column" fxLayoutGap="15px">
        <div class="map-container p-3 mt-2" #mapContainer>
          <mtn-map [options]="mapOptions" (ready)="onMapReady($event)"></mtn-map>
          <mtn-store-spotlight-panel-for-point-click class="mtn-store-spotlight-panel" #storeSpotlightPanel [map]="map"
            *ngIf="map?.selections.size === 1"></mtn-store-spotlight-panel-for-point-click>
        </div>
      </div>
    </div>

<mtn-competitive-analysys
  *ngIf="isSubmitted && coardinates"
  [coardinates]="coardinates"
  [location]=" wizard?.model?.location"
  [trackingContext]="{ grocer: newUserForm?.value?.grocer, location: wizard?.model?.location ,sqft: newUserForm?.value?.sqft,cbsaName:marketAreaCoardinates?.getFeature()?.properties?.name }"
  (dataEmitter)="handleChildData($event)"
  (regionAndComparType)="handleRegionAndCompareType($event)">
</mtn-competitive-analysys>


  <div [ngClass]="!isSubmitted ? 'hide' : '' " class="demographic-view">
    <div class="comparison-detail-page-container container" fxLayout="column" fxLayoutGap="15px">
    <mtn-store-demographic-profile-panel [location]=" wizard?.model?.location" (regionTypeAndValueEmitter)="handleRegionTypeAndValueEmitter($event)" (dataEmitter)="handleChildDataFromDemographic($event)" [coardinates]="this.wizard.model" [storeAnalysys]="true"></mtn-store-demographic-profile-panel>
    </div>
  </div>

</div>
<!-- <div class="beta-text">
  The Point-and-click feature remains in beta and is trained on legacy data at this stage. We’re actively refining our model to improve speed, usability, and accuracy. Full data coverage is scheduled for release in Q4 2025
</div> -->
